(() => {
  const PICKUP_ADDRESS = { address1: '3181 Wolfedale Road', address2: '', city: 'Mississauga', province: 'ON', country: 'CA', zip: 'L5C 1V8' };

  const lockPickupTime = () => document.querySelectorAll('.ds-Select__Wrapper').forEach((wrapper) => {
    if (wrapper.querySelector('.ds-Select__Value')?.textContent.trim() !== '01:00 PM - 03:00 PM') return;
    wrapper.classList.add('kaylulu-fixed-pickup-time');
    wrapper.setAttribute('tabindex', '-1');
    wrapper.setAttribute('aria-disabled', 'true');
  });

  const setAttributes = async (method, date) => {
    const root = window.Shopify?.routes?.root || '/';
    const attributes = {
      'Delivery order': method === 'pickup' ? 'Mississauga Pickup' : 'Shipping',
      'ds-method': method,
      'Pickup schedule': method === 'pickup' ? `Saturday ${date}, 1:00 PM–3:00 PM` : '',
      'Pickup handling fee': method === 'pickup' ? '$13.99 CAD' : '',
      'ds-location': method === 'pickup' ? '5471' : '',
      'ds-date': method === 'pickup' ? date : '',
      Date: method === 'pickup' ? `${date}T17:00:00.000Z` : ''
    };
    const response = await fetch(`${root}cart/update.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes })
    });
    if (!response.ok) throw new Error('Cart update failed');
  };

  const checkoutUrl = (method, themeId) => {
    const root = window.Shopify?.routes?.root || '/';
    // Shipping orders must use Shopify's native checkout without DS pickup
    // parameters or blank pickup-address fields. Those parameters can keep the
    // checkout in the app's pickup context and prevent normal rates loading.
    if (method === 'shipping') return `${window.location.origin}${root}checkout`;
    const params = new URLSearchParams({ ds: 'true', method, preview_theme_id: themeId, skip_shopify_pay: 'true' });
    Object.entries(PICKUP_ADDRESS).forEach(([key, value]) => params.set(`checkout[shipping_address][${key}]`, value));
    return `${window.location.origin}${root}checkout?${params.toString()}`;
  };

  const init = () => {
    const root = document.querySelector('[data-split-checkout]');
    if (!root || root.dataset.kayluluBound === 'true') return;
    root.dataset.kayluluBound = 'true';
    const allPickupEligible = root.dataset.allPickupEligible === 'true';
    document.documentElement.classList.toggle('kaylulu-shipping-only-cart', !allPickupEligible);
    const radios = [...root.querySelectorAll('input[name="kaylulu-order-method"]')];
    const requestedMethod = new URL(window.location.href).searchParams.get('kaylulu_method');
    const requestedRadio = radios.find((radio) => radio.value === requestedMethod);
    if (requestedRadio && (requestedMethod !== 'pickup' || allPickupEligible)) requestedRadio.checked = true;
    const checkout = root.querySelector('[data-order-checkout]');
    const checkoutLabel = checkout?.querySelector('.button-text');
    const status = root.querySelector('[data-checkout-status]');
    const pickupSchedule = root.querySelector('[data-pickup-schedule]');
    const pickupDateInput = root.querySelector('[data-pickup-date]');
    let busy = false;
    const method = () => radios.find((radio) => radio.checked)?.value || '';
    const date = () => pickupDateInput?.value || '';
    let persistTimer;

    if (pickupDateInput && pickupDateInput.options.length === 1) {
      const first = new Date();
      first.setHours(12, 0, 0, 0);
      first.setDate(first.getDate() + 5);
      while (first.getDay() !== 6) first.setDate(first.getDate() + 1);
      for (let index = 0; index < 3; index += 1) {
        const day = new Date(first);
        day.setDate(first.getDate() + (index * 7));
        const value = day.toISOString().slice(0, 10);
        const label = `${day.toLocaleDateString('en-CA', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' })} · 1:00–3:00 PM`;
        pickupDateInput.add(new Option(label, value));
      }
    }

    const update = () => {
      const selected = method();
      if (pickupSchedule) pickupSchedule.hidden = selected !== 'pickup';
      if (checkoutLabel && !busy) checkoutLabel.textContent = selected === 'pickup' ? 'Continue to pickup checkout'
        : selected === 'shipping' ? 'Continue to shipping checkout' : 'Continue to checkout';
      const ready = selected === 'shipping' || (selected === 'pickup' && allPickupEligible && date());
      checkout.disabled = !ready || busy;
      checkout.setAttribute('aria-disabled', String(!ready || busy));
      status.dataset.error = String(Boolean(selected) && !ready);
      status.dataset.ready = String(ready);
      status.textContent = !selected ? 'Choose a delivery method to continue.'
        : selected === 'pickup' && !date() ? 'Choose an available Saturday. Pickup time is fixed at 1:00–3:00 PM.' : '';
    };

    const persistChoice = () => {
      window.clearTimeout(persistTimer);
      persistTimer = window.setTimeout(() => {
        const selected = method();
        if (selected) setAttributes(selected, date()).catch(() => {});
      }, 80);
    };

    pickupDateInput?.addEventListener('change', () => { update(); persistChoice(); });

    radios.forEach((radio) => {
      // Keep the DS app's global cart click handler from treating Kaylulu's
      // order-method radios as its own controls and launching a stale checkout.
      radio.addEventListener('click', (event) => event.stopPropagation());
      radio.addEventListener('change', () => { update(); persistChoice(); });
    });

    const prepareCheckout = async (event) => {
      event?.preventDefault();
      event?.stopImmediatePropagation();
      const selected = method();
      const pickupDate = date();
      if (busy || !selected || (selected === 'pickup' && (!allPickupEligible || !pickupDate))) return;
      busy = true; update(); status.textContent = 'Preparing your checkout…';
      try {
        await setAttributes(selected, pickupDate);
        window.location.assign(checkoutUrl(selected, root.dataset.themeId));
      } catch (_) {
        busy = false; status.dataset.error = 'true'; status.textContent = 'We could not prepare checkout. Please try again.'; update();
      }
    };

    // Capture every possible cart checkout entry point. This prevents theme,
    // app, keyboard-submit, or stale fallback buttons from bypassing Pickup
    // address/fee preparation.
    const captureCheckoutClick = (event) => {
      const target = event.target.closest('[data-order-checkout], #checkout, [name="checkout"], shopify-accelerated-checkout-cart, .shopify-payment-button');
      if (target) prepareCheckout(event);
    };
    const captureCheckoutSubmit = (event) => {
      const submitter = event.submitter;
      if (submitter?.matches('#checkout, [name="checkout"]')) prepareCheckout(event);
    };
    document.addEventListener('click', captureCheckoutClick, true);
    document.addEventListener('submit', captureCheckoutSubmit, true);

    let signature = '';
    const watcher = window.setInterval(() => {
      if (!document.contains(root)) return window.clearInterval(watcher);
      lockPickupTime();
      const next = `${method()}|${date()}`;
      if (next !== signature) { signature = next; update(); }
    }, 350);
    update();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
